'use client';
import { SPACING_3, SPACING_6 } from '@mnd-frontend/ui/shared/tokens';
import type React from 'react';
import styled from 'styled-components';
import { Button } from '../Button';
import Symbols, { type SymbolsType } from '../Symbols';
import { Text } from '../Text';

const EmptyStateWrapper = styled.div`
  padding: ${SPACING_6};
  text-align: center;
`;
const ButtonWrapper = styled.div`
  margin-top: ${SPACING_3};
`;

const EmptyState = ({
  headline,
  symbol: Symbol = Symbols.NoResults,
  description,
  action,
  onClick,
  testId,
  href,
  tonedButton,
  ...props
}: {
  headline?: string;
  symbol?: SymbolsType;
  description?: string | JSX.Element;
  action?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement, MouseEvent>) => void;
  testId?: string;
  tonedButton?: boolean;
  href?: string;
}) => (
  <EmptyStateWrapper data-testid={testId} {...props}>
    <Symbol size="large" />
    <Text as="h3" variant="headlineSmall" marginTop="SPACING_2">
      {headline}
    </Text>
    {description && (
      <Text as="p" variant="body" marginTop="SPACING_1">
        {description}
      </Text>
    )}
    {action &&
      (href ? (
        <ButtonWrapper>
          <Button configuration={tonedButton ? 'toned' : 'filled'} href={href} onClick={onClick}>
            {action}
          </Button>
        </ButtonWrapper>
      ) : onClick ? (
        <ButtonWrapper>
          <Button configuration={tonedButton ? 'toned' : 'filled'} type="button" onClick={onClick}>
            {action}
          </Button>
        </ButtonWrapper>
      ) : null)}
  </EmptyStateWrapper>
);

export default EmptyState;
